import { defineMessages } from 'react-intl';
import labels from 'utils/labels';

export default defineMessages({
  title: {
    id: 'login_page.title',
  },
  secondTitle: {
    id: 'login_page.Secondtitle',
  },
  subTitle: {
    id: 'login_page.sub_title',
  },
  formTitle: {
    id: 'login_page.form.se_connecter',
  },
  formSubTitle: {
    id: 'login_page.form.sub_title',
  },
  identifiant: {
    id: 'login_page.form.identifiant',
  },
  password: {
    id: 'login_page.form.password',
  },
  forgotLingOrPass: {
    id: 'login_page.form.forgot_password',
  },
  rememberMe: {
    id: 'login_page.form.remember_me',
  },
  seConnecter: {
    id: 'login_page.form.se_connecter',
  },
  or: {
    id: 'login_page.form.ou',
  },
  firstVisit: {
    id: 'login_page.form.first_visit',
  },
  createAccount: {
    id: 'login_page.form.create_account',
  },
  requiredField: {
    id: 'required.field',
  },
  modalHeader: {
    id: 'info.modal_header',
  },
  modalContent: {
    id: 'info.modal_content',
  },
  close: {
    id: 'modal.close',
  },
  accountLocked: {
    id: 'login_page.error_account_locked',
  },
  loginError: {
    id: 'login_page.error_password_login',
  },
  auto: {
    id: 'auto_details.auto',
  },
  mrh: {
    id: 'bread_crumbs.habitation',
  },
  epargn: {
    id: 'bread_crumbs.epargn',
  },
  declaration_tite: {
    id: 'login.title_1',
  },
  sinistre: {
    id: 'login.title_2',
  },
  contrat_title: {
    id: 'login.title_3',
  },
  epargn_situation: {
    id: 'login.title_4',
  },
  health: {
    id: 'amc_details.amc',
  },
  healthTitle: {
    id: labels.doHealthDeclaration,
  },
  amcConnect: {
    id: labels.amcConnect,
  },
  forgotPassword: {
    id: labels.forgotPassword,
  },
  minutes: {
    id: 'timeUnit_minutes',
  },
  hours: {
    id: 'timeUnit_hour',
  },
  days: {
    id: 'timeUnit_days',
  },
});
